export default __webpack_public_path__ + "35bd5d5e65be179b1995b9d7a0cba465.png";